import React from 'react';
import {News} from './news';
import style from './style.scss';
import {BusinessNotification} from './notification';
import {Statistical} from './statistical';
import {NewOrder} from './new-order';
import {AnnouncementBlock} from 'components/partials/announcement-block';

class TheNews extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <section className="the-news">
        {/* <News/> */}
        <div className='the-news-wrap-container'>
          <AnnouncementBlock/>
          <NewOrder/>
          <Statistical title='Thống kê'/>
        </div>
      </section>
    );
  }
}

export default TheNews;



// WEBPACK FOOTER //
// ./components/my-business/sub-view/the-news/TheNews.jsx